// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"6713569f","590":"0cfbd687","787":"b2cb7c0f"}[chunkId] + ".chunk.js";
};